const paymentsCreditTranslate: Record<string, string> = {
  '12': '12',
  '18': '18',
  '24': '24',
  '36': '36',
  '48': '48',
  '60': '60',
}

export default paymentsCreditTranslate
